import script from "./AnexoUploadField.vue?vue&type=script&setup=true&lang=js"
export * from "./AnexoUploadField.vue?vue&type=script&setup=true&lang=js"

import "./AnexoUploadField.vue?vue&type=style&index=0&id=c0c6c26e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0c6c26e"]])

export default __exports__